module.exports = __webpack_public_path__ + "img/crusher.802bdfd1.png";